import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { SelectModel } from 'src/app/shared/models/search.model';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
declare var jQuery: any;

@Component({
  selector: 'app-sample-newsletter',
  templateUrl: './sample-newsletter.component.html',
  styleUrls: ['./sample-newsletter.component.scss']
})
export class SampleNewsletterComponent implements OnInit, AfterViewInit {

  public wait: boolean = false;
  public submit: boolean = false;
  public disabled: boolean = true;
  public professorsChecked: boolean = false;
  private currentSelectedProfessors: any = [];

  @Input() lang: string = "";
  @Input() block: any;
  @Output() onFiltered = new EventEmitter();

  public emailBlock: any;
  private registrations: any = [];
  public listNewsletter: any = [];
  private listSelected: any = {};
  public listProfessors: any = {};
  public emailSelected: string = "";
  public chosenAreas: boolean = false;
  public visibleProfessors: boolean = false;
  public resetValueCheckbox: boolean = false;
  public isVisibleReset: boolean = false;
  public checkInformativaAvvisi : boolean = false;
  private code: any;

  // SELECT
  public checkboxGroupForm!: FormGroup;
  public checkArray!: Observable<any>;
  public titleDropdown: string = '';
  public isValue: boolean = false;
  private selectedValue: string = '';
  public itemLength: number = 0;
  public viewMore = false;
  public window: any;

  public modelCheckBoxes:any = [];

  get ordersFormArray() {
    return this.checkboxGroupForm.controls['checkbox'] as FormArray;
  }

  constructor(private nodeService: NodeService, private helpersService: HelpersService, private formBuilder: FormBuilder) {
      this.checkboxGroupForm = this.formBuilder.group({
        checkbox: new FormArray([])
      });
    }

  ngOnInit(): void {
    this.getNewsLetter();
    this.window = this.nodeService.getWindow();
  }

  ngAfterViewInit(): void {
    this.createCaptchas();
  }

  public createCaptchas(): void {
    this.createCaptcha("captcha");
    this.createCaptcha("captchaUnsub");
  }

  private createCaptcha(box: any) {
    //clear the contents of captcha div first 
    if (this.helpersService.isBrowser) {
      
      const captchaBox: any = document.getElementById(box);
      if (captchaBox) {
        captchaBox.innerHTML = "";
        var charsArray =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lengthOtp = 6;
        var captcha = [];
        for (var i = 0; i < lengthOtp; i++) {
          //below code will not allow Repetition of Characters
          var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
          if (captcha.indexOf(charsArray[index]) == -1)
            captcha.push(charsArray[index]);
          else i--;
        }
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 200;
        canv.height = 50;
        var ctx: any = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.strokeText(captcha.join(""), 0, 30);
        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        this.code = captcha.join("");
        captchaBox.appendChild(canv); // adds the canvas to the body element
      }
    }
  }
  
  public validateCaptcha(box: any, textBox: any) {
    const cpatchaTextBox: any = document.getElementById(textBox);
    if (cpatchaTextBox && cpatchaTextBox['value'] === this.code) {
      this.disabled = false;
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.VALIDATED");
      this.helpersService.showToast(message, "success");
    }else{
      this.disabled = true;
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.UNVALIDATED");
      this.helpersService.showToast(message, "danger");
      this.createCaptcha(box);
    }
  }

  private getNewsLetter() {
    this.wait = true;
    this.nodeService.getNewsletter(this.lang).subscribe(res => {
      this.emailBlock = {
        label_it: "Email",
        label_en: "Email"
      }
      this.registrations = Object.keys(res);
      for (let reg of this.registrations) {
        const tmp: any = {
          name: reg,
          filter_type: 'vocabulary[]',
          value:  [],
          label_it: this.nodeService.getIstant(`CONTENT_TYPES.PAGE_NEWSLETTER.${reg.toUpperCase()}`),
          label_en: this.nodeService.getIstant(`CONTENT_TYPES.PAGE_NEWSLETTER.${reg.toUpperCase()}`)
        }
        for (let val of res[reg]) {
          tmp.value.push({term_id: val.id ? val.id : val.value, name:val.name ? val.name : val.label, related_courses: val.related_courses ? val.related_courses : null})
        }
        this.listNewsletter.push(tmp);
      }
      this.wait = false;
    }, (err: any) => {
      this.wait = false;
    })
  }

  public onSelectedAree(event: any, regType: string) {
    this.resetValueCheckbox = false;
    let regTypeSplitted = regType.split("_");
    let regTypeCamelCase: string = regType;
    for(let r of regTypeSplitted) {
      regTypeCamelCase = regTypeCamelCase.replaceAll("_" + r[0], r[0].toUpperCase());
    }
    let regTypeIds = regTypeCamelCase + "Ids";
    let ids: any = [];
    for(event of event.values_selected) {
      ids.push(Number(event.term_id));
    }
    this.listSelected[regTypeIds] = ids;
    if(this.listSelected["areeUniversitaIds"] && this.listSelected["areeUniversitaIds"].length !== 0){
      this.chosenAreas = true;
    } else {
      this.chosenAreas = false;
    }
    this.isVisibleReset = true;
  }

  public onSelectedCorsi(event: any, regType: string) {
    this.modelCheckBoxes = [];
    this.resetValueCheckbox = false;
    let regTypeSplitted = regType.split("_");
    let regTypeCamelCase: string = regType;
    for(let r of regTypeSplitted) {
      regTypeCamelCase = regTypeCamelCase.replaceAll("_" + r[0], r[0].toUpperCase());
    }
    let regTypeIds = regTypeCamelCase + "Ids";
    let ids: any = [];
    for(event of event.values_selected) {
      ids.push(Number(event.term_id));
    }
    this.listSelected[regTypeIds] = ids;
    if(this.listSelected["corsiDiLaureaIds"] && this.listSelected["corsiDiLaureaIds"].length !== 0){
      this.visibleProfessors = true;
      this.filterProfessors();
      this.initSelect();
    } else {
      this.visibleProfessors = false;
    }
    this.isVisibleReset = true;
    this.selectProfessor();

  }

  private selectProfessor() {
    const fg: any = this.ordersFormArray.controls[0];
    this.modelCheckBoxes = [];
    for (let ctrl of Object.keys(fg.controls)) {
      const term_id = ctrl.split("_")[1];
      const foundChecked = this.currentSelectedProfessors.findIndex((p: any) => p.term_id == term_id);
      if (foundChecked >= 0) {
        this.modelCheckBoxes.push(true);
        fg.controls[ctrl].setValue(true);
        const checkEl: any = document?.getElementById(ctrl) as HTMLInputElement;
        checkEl.checked = true;
      } else {
        this.modelCheckBoxes.push(false);
      }
    }
    this.submitSelect();
  }

  private filterProfessors() {
    this.listProfessors = {
      name: this.registrations[this.registrations.length-1],
      filter_type: 'vocabulary[]',
      value:  [],
      label_it: this.nodeService.getIstant(`CONTENT_TYPES.PAGE_NEWSLETTER.${this.registrations[this.registrations.length-1].toUpperCase()}`),
      label_en: this.nodeService.getIstant(`CONTENT_TYPES.PAGE_NEWSLETTER.${this.registrations[this.registrations.length-1].toUpperCase()}`)
    }
    const types = Object.keys(this.listSelected);
    let pushedListSelected: any = [];
    for(let type of types) {
      for(let number of this.listSelected[type])
      pushedListSelected.push(Number(number));
    }
    let found: boolean = false;
    for(let related of this.listNewsletter[this.listNewsletter.length-1].value) {
      found = false;
      for(let course of related.related_courses) {
        let relatedCourse = pushedListSelected.filter((n: any) => n == course);
        if(relatedCourse.length) {
          found = true;
          break;
        }
      }
      if(found){
        this.listProfessors.value.push(related);
        this.visibleProfessors = true;
      }
    }
  }

  public onSelectedProfessor(professors: any) {
    this.resetValueCheckbox = false;
    let regTypeIds = this.listProfessors.name + "Ids";
    let ids: any = [];
    for(let professor of professors) {
      ids.push(Number(professor.term_id));
    }
    this.listSelected[regTypeIds] = ids;
    if(ids.length != 0) {
      this.professorsChecked = true;
    } else {
      this.professorsChecked = false;
    }
    this.isVisibleReset = true;
  }

  public onTypedEmail(event: any) {
    this.resetValueCheckbox = false;
    this.emailSelected = event;
  }

  public resetSearch() {
    this.resetValueCheckbox = true;
    this.listSelected = {};
    this.emailSelected = "";
    this.disabled = true;
    this.professorsChecked = false;
    this.visibleProfessors = false;
    this.listProfessors = {};
    this.createCaptchas();
    this.isVisibleReset = false;
  }

  public subscribe() {
    this.submit = true;
    for(let newsletter of this.listNewsletter) {
      let regTypeSplitted = newsletter.name.split("_");
      let regTypeCamelCase: string = newsletter.name;
      for(let r of regTypeSplitted) {
        regTypeCamelCase = regTypeCamelCase.replaceAll("_" + r[0], r[0].toUpperCase());
      }
      let regTypeIds = regTypeCamelCase + "Ids";
      if(!this.listSelected[regTypeIds] || !this.listSelected[regTypeIds].length) {
        this.listSelected[regTypeIds] = [];
      }
    }
    this.listSelected["email"] = this.emailSelected;
    this.listSelected["mode"] = "register";
    this.helpersService.sendSubscriptionNewsletter(this.listSelected, this.lang).subscribe(res => {
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.SUBSCRIBED");
      this.helpersService.showToast(message, "success");
      this.submit = false;
      this.resetSearch();
    }, err => {
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.GOT_PROBLEM");
      this.helpersService.showToast(message, "danger");
      this.submit = false;
    })
  }

  public unsubscribe() {
    this.submit = true;
    this.listSelected = {};
    this.listSelected["email"] = this.emailSelected;
    this.listSelected["mode"] = "cancellation";
    this.helpersService.sendUnsubsciptionNewsletter(this.listSelected, this.lang).subscribe(res => {
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.UNSUBBED");
      this.helpersService.showToast(message, "success");
      this.submit = false;
      this.resetSearch();
    }, err => {
      const message = this.helpersService.getIstant("CONTENT_TYPES.PAGE_NEWSLETTER.GOT_PROBLEM");
      this.helpersService.showToast(message, "danger");
      this.submit = false;
    })
  }

  // Select
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetValueCheckbox']) {
      this.checkboxGroupForm.reset();
      this.isValue = false;
      this.titleDropdown = this.listProfessors.label_it;
    }
  }

  private initSelect(): void {
    this.checkboxGroupForm.reset();
    this.checkboxGroupForm.controls['checkbox'] = new FormArray([]);
    this.isValue = false;
    this.titleDropdown = this.listProfessors.label_it;
    this.addCheckboxes();
    this.titleDropdown = this.listProfessors.label_it;
    this.checkArray = of(this.listProfessors.value);
  }

  private addCheckboxes(): void {
    
    let group = new FormGroup({});
    for (let prof of this.listProfessors.value) {
      group.addControl("docente_" + prof.term_id, new FormControl(false));
    }
    this.ordersFormArray.push(group);
    
  }

  private setTitleDropdown(selectedCheckbox: any[]): void {
    if (selectedCheckbox.length === 1) {
      this.isValue = true;
      this.itemLength = 0;
      this.titleDropdown = selectedCheckbox[0].name;
    } else if (selectedCheckbox.length > 1) {
      this.isValue = true;
      this.itemLength = selectedCheckbox.length;
      this.titleDropdown = `${this.itemLength} ${this.listProfessors.label_it}`
    } else {
      this.isValue = false;
      this.itemLength = 0;
      this.titleDropdown = this.listProfessors.label_it;
    }
  }

  public submitSelect(): void {
    let selValue: string = '';
    const value = this.modelCheckBoxes.map((checked: any, i: any) => checked ? this.listProfessors.value[i] : null).filter((v: null) => v !== null);
    this.onSelectedProfessor(value);
    this.selectedValue = selValue;
    this.setTitleDropdown(value);
    this.currentSelectedProfessors = value;
  }

}
